export default __webpack_public_path__ + "static/media/ut__bg.45f7d833.png";